import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Notification, { showToast } from '../../../components/common/notification/Notification';
import Spinner from '../../../components/common/spinner/Spinner';
import RowList from '../../components/listing/RowList';
import { Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import Pagination from '../../components/pagination/Pagination';
import PropertyFilter from './PropertyFilter';
import { Link } from "react-router";
import { IoMdAdd } from "react-icons/io"; 
import "../postAdmin/filter.css";

const PropertyListComponent = ({  
  route,
  method, 
  requiresAuth, 
  apiPath,
  mySpace = false,
  selectedValue = null, // Used for filtering in mySpace
}) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const assetUrl = process.env.REACT_APP_ASSET_URL;
  // const token = loggedInUser?.token; 
  const token = loggedInUser?.refreshToken; 
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false); 
  const [searchTerm, setSearchTerm] = useState(''); 
  const [filteredProperties, setFilteredProperties] = useState([]);

  useEffect(() => {
    fetchData();
  }, [currentPage]); 

  const fetchData = async () => {
    try {
      setIsLoading(true);
      let response;

      if (method === "GET") {
        response = await axios.get(`${baseUrl}${apiPath}`);
      } else {
        // console.log('atleast post was seen')
        // console.log('selectedValue', selectedValue);
        response = await axios.post(
          `${baseUrl}${apiPath}`,
          {
            keyboard_search: "",
            page_number: currentPage,
            page_size: 20,
            order_by: "ABC",
            ...(mySpace && { search_type: selectedValue })
          },
          requiresAuth
            ? {
                headers: { Authorization: `Bearer ${token}` },
              }
            : undefined
        );
      }
      // console.log("property", response.data.properties);
      if (response.status === 200 && response.data.statusType === "SUCCESS") {
        setProperties(response.data.properties || []);
        setTotalPages(response.data.totalPage || 1);
      } else {
        showToast("Failed to fetch Property data", { type: "error" });
      }
    } catch (error) {
      setIsError(true);
      showToast("Error fetching Property data", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/property/deleteProperty/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.statusType === 'SUCCESS') {
        setProperties(properties.filter((item) => item.id !== itemId));
        showToast('Property deleted successfully', { type: 'success' });
      } else {
        showToast(`${response.data.text}`, { type: 'error' });
      }
    } catch (error) {
      console.error('Error deleting Property :', error);
      showToast('Error occurred during deletion', { type: 'error' });
    }
  };

  // follow unfolllow toggle 
  const handleFollowOption = async (id, isFavorite, favoriteId) => {
    console.log("isFavorite", isFavorite);
    if (isFavorite && favoriteId) {
      // Unfollow
      try {
        const removeFavourite = await axios.delete(
          `${baseUrl}/property/favorite/delete/${favoriteId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (removeFavourite.data.statusType === "SUCCESS") {
          showToast("Property Removed From Favourite", { type: "success" });
          setProperties((prev) =>
            prev.map((prop) =>
              prop.id === id
                ? { ...prop, is_favorite: false, favorite: false }
                : prop
          ));
          
        } else {
          showToast("Error Removing Property From Favourite", { type: "error" });
        }
      } catch (err) {
        console.log(err)
        showToast("Error Removing Property From Favourite", { type: "error" });
      }
    } else {
      // Follow
      try { 
        const addFavourite = await axios.post(
          `${baseUrl}/property/favorite/add`,
          { property_id: id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (addFavourite.data.statusType === "SUCCESS") { 
          showToast("Property Added To Favourite", { type: "success" });
          setProperties((prev) =>
            prev.map((prop) =>
              prop.id === id
                ? { ...prop, is_favorite: true, favorite: true }
                : prop
          )); 
        } else {
          showToast("Error Adding Property To Favourite", { type: "error" });
        }
      } catch (err) { 
        console.log(err)
        showToast("Error Adding Property To Favourite", { type: "error" });
      }
    }
  };

  // share 
const handleShareToggle = async (id, isShared) => {
  try {
    const response = await axios.post(
      `${baseUrl}/property/shared`,
      {
        property_id: id, 
        is_shared: !isShared,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Share response:", response.data); 
    if (response.data.statusType === "SUCCESS") {
      showToast(
        !isShared ? "Property shared successfully" : "Property unshared",
        { type: "success" }
      );
      setProperties((prev) =>
        prev.map((prop) =>
          prop.id === id ? { ...prop, is_shared: !isShared } : prop
        )
      );
    } else {
      showToast("Failed to update share status", { type: "error" });
    }
  } catch (error) {
    showToast("Error updating share status", { type: "error" });
  }
};

  // publish/unpublish toggle handler
  const handleToggleEnable = async (itemId) => {
    const current = properties.find((p) => p.id === itemId);
    const newPublishStatus = !current.is_published;

    try {
      const response = await axios.put(
        `${baseUrl}/property/publish/status`,
        {
          lead_id: itemId,
          is_publish: newPublishStatus,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response?.data?.statusType === "SUCCESS") {
        const updated = properties.map((prop) =>
          prop.id === itemId ? { ...prop, is_published: newPublishStatus } : prop
        );
        setProperties(updated);

        showToast(
          newPublishStatus ? "Property published successfully" : "Property unpublished successfully",
          { type: "success" }
        );
      } else {
        showToast("Failed to update property status", { type: "error" });
      }
    } catch (error) {
      console.error("Error updating property status:", error);
      showToast("Error updating property status", { type: "error" });
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (!term) {
      setFilteredProperties([]);
      return;
    }

    const filtered = properties.filter((property) => {
      const fname = property.customer?.first_name?.toLowerCase() || ''; 
      const lname = property.customer?.last_name?.toLowerCase() || '';
      const title = property.title?.toLowerCase() || '';
      const description = property.description?.toLowerCase() || '';
      const area = property.area?.name?.toLowerCase() || '';
      const city = property.city?.name?.toLowerCase() || '';
      const state = property.state?.name?.toLowerCase() || '';
      const country = property.country?.name?.toLowerCase() || '';

      return (
        fname.includes(term) ||
        lname.includes(term) ||
        title.includes(term) ||
        description.includes(term) ||
        area.includes(term) ||
        city.includes(term) ||
        state.includes(term) ||
        country.includes(term)
      );
    });

    setFilteredProperties(filtered);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

const applyCustomFilters = (filters) => {
  const filtered = properties.filter((prop) => {
    const matchPurpose = !filters.purpose || String(prop.purpose?.id) === String(filters.purpose);
    const matchState = !filters.state || String(prop.state?.id) === String(filters.state);
    const matchCity = !filters.city || String(prop.city?.id) === String(filters.city);
    const matchArea = !filters.area || String(prop.area?.id) === String(filters.area);
    const matchType = !filters.type || String(prop.type?.id) === String(filters.type);
    const matchSubType = !filters.subType || String(prop.sub_type?.id) === String(filters.subType);
    const matchSubSubType = !filters.subSubType || String(prop.sub_sub_type?.id) === String(filters.subSubType);

    const matchesSearch = !searchTerm || (
      prop.customer?.first_name?.toLowerCase().includes(searchTerm) ||
      prop.customer?.last_name?.toLowerCase().includes(searchTerm) ||
      prop.title?.toLowerCase().includes(searchTerm) ||
      prop.description?.toLowerCase().includes(searchTerm)
    );

    return (
      matchPurpose &&
      matchState &&
      matchCity &&
      matchArea &&
      matchType &&
      matchSubType &&
      matchSubSubType &&
      matchesSearch
    );
  });

  setFilteredProperties(filtered);
};

  // After fetching properties, extract unique options for each filter
  const getUniqueOptions = (arr, path) => {
    const seen = new Set();
    return arr
      .map(item => {
        const value = path.split('.').reduce((o, k) => (o ? o[k] : undefined), item);
        return value ? { id: value.id, name: value.name } : null;
      })
      .filter(opt => { 
        if (opt && !seen.has(opt.id)) {
          seen.add(opt.id);
          return true;
        }
        return false;
      });
  };

  const purposes = getUniqueOptions(properties, 'purpose');
  const states = getUniqueOptions(properties, 'state');
  const cities = getUniqueOptions(properties, 'city');
  const areas = getUniqueOptions(properties, 'area');
  const types = getUniqueOptions(properties, 'type');
  const subTypes = getUniqueOptions(properties, 'sub_type');
  const subSubTypes = getUniqueOptions(properties, 'sub_sub_type');


  return (  
    <>
      <Notification /> 

      <div className="algn-items-center ">
        {/* <Row className="align-items-center justify-content-center my-4 mx-2">
          <Col lg={8} md={12} sm={12} className='w-100'>
            <InputGroup> 
              <Form.Control
                className='bg-white'
                placeholder="Search by name, city, state, country..."
                value={searchTerm}
                onChange={handleSearch} 
              />
              <Button variant="dark me-2">Search</Button> 
              <PropertyFilter
                purposes={purposes}
                states={states}
                cities={cities}
                areas={areas}
                types={types}
                subTypes={subTypes}
                subSubTypes={subSubTypes}
                onFilter={applyCustomFilters}
              />
            </InputGroup>
          </Col>
            <Link
              className="btn btn-primary btn-lg w-20 my-3 "
              to="/add-property"
            >
              <IoMdAdd className='fs-2' />
            </Link>
        </Row> */}

        {/* new */}
        <Row className="my-2 px-3">
          <Col xs={12}>
            <div className="toolbar-container">

              {/* SEARCH INPUT + FILTERS */}
              <InputGroup className="toolbar-search">
                <Form.Control
                  placeholder="Search by name, city, state, country..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="bg-white"
                />

                <Button variant="dark" className='me-2'>Search</Button>

                <PropertyFilter
                  purposes={purposes}
                  states={states}
                  cities={cities}
                  areas={areas}
                  types={types}
                  subTypes={subTypes}
                  subSubTypes={subSubTypes}
                  onFilter={applyCustomFilters}
                />
              </InputGroup>

              {/* ADD PROPERTY BUTTON */}
              <Link to="/add-property" className="toolbar-add-btn">
                <IoMdAdd />
              </Link>

            </div>
          </Col>
        </Row>

        <Row className='d-flex justify-content-center'>
          <Col>
            {isLoading ? (
              <Spinner loading={true} />
            ) : (
              (filteredProperties.length > 0 || searchTerm ? filteredProperties : properties).map((item) => (
                <RowList
                  key={item.id}
                  title={item.title}
                  creator={`${item.customer?.first_name || ''} ${item.customer?.last_name || ''}`}
                  // CardImg={assetUrl + (item.images?.[0]?.image_url || '')}
                  CardImg={item?.images?.[0]?.image_url ? (assetUrl + item.images[0].image_url) : null}
                  createOn={item.purpose.created_on}
                  item={item}
                  handleDelete={handleDelete}
                  handleToggleEnable={handleToggleEnable} 
                  route={route}
                  checkBox={item.is_published}
                  isFollowing={item.is_favorite || item.favorite}
                  onToggleFollow={() => handleFollowOption(item.id, item.is_favorite, item.favorite_id)}
                  isShared={item.is_shared || false}
                  onToggleShare={() => handleShareToggle(item.id, item.is_shared)}
                />
              )) 
            )}
          </Col>
          <div className="mt-2 mb-4 d-flex justify-content-center">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages} 
              onPageChange={handlePageChange}
            />
          </div>
        </Row>
      </div>
    </>
  ); 
};

export default PropertyListComponent;
